import { render, staticRenderFns } from "./GameHeader.vue?vue&type=template&id=a228ca74&scoped=true&"
import script from "./GameHeader.vue?vue&type=script&lang=js&"
export * from "./GameHeader.vue?vue&type=script&lang=js&"
import style0 from "./GameHeader.vue?vue&type=style&index=0&id=a228ca74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a228ca74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VBtnToggle,VCard,VCol,VContainer,VIcon,VRow})
